module.exports = __webpack_public_path__ + "static/media/19068_1317079333783_3102792_n.b4e86ec3.jpg";